/* eslint-disable import/prefer-default-export */

export const orderCardFlowScreens = {
  CARD_TYPE: 'card_type',
  CONFIRM_DETAILS: 'confirm_details',
  CONFIRM_VIRTUAL_DETAILS: 'confirm_virtual_details',
  SET_PIN: 'set_pin',
  SELECT_PAYMENT: 'select_payment',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
  SELECT_PAYMENT_TYPE: 'select_payment_type',
  CONFORM_PAYMENT_DETAILS: 'confirm_payment_details',
  MULTI_CURRENCY_INFO: 'multi_currency_into',
  LEDGER_DEPOSIT: 'ledger_deposit',
  TRANSACTION_PROCESSED: 'transaction_processed',
  RECEIVE: 'receive',
  FREE_CARD_PROMO: 'free_card_promo',
  DEPOSIT_WALLET_SELECTION: 'deposit_wallet_selection',
  CARD_TERMS: 'card_terms',
  SELECT_CARD_TYPE: 'select_card_type',
};

export const CardPaymentMethods = {
  FIAT: 'fiat',
  CRYPTO_OR_STABLE: 'crypto_or_stable',
  PGW: 'pgw',
};

export const CARD_TYPE = {
  virtual: {
    state: 'virtual_card_option',
    note: 'virtual_card_option_note',
  },
  physical: {
    state: 'physical_card_option',
    note: 'physical_card_option_note',
  },
};

export const mainCardTypes = {
  PHYSICAL: 'physical',
  VIRTUAL: 'virtual',
};
export const CARD_TYPE_STATUS = {
  PHYSICAL: 'physical_card_option',
  VIRTUAL: 'virtual_card_option',
};
